import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import CustomSelect from '../../GlobalComponents/CustomSelect'

var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
  };

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionGender : [
                { label: "Dinas Luar", value: "Dinas Luar" },
                { label: "Tugas Belajar", value: "Tugas Belajar" }
            ],
            optionNational : [
                { label: "Dalam Negeri", value: "Dalam Negeri" },
                { label: "Luar Negeri", value: "Luar Negeri" }
              ],
            selectedGender: "",
            birthSelectedCountry: "444fbff9-52d6-4d61-9150-b5060055e560", // Kepala Perpu
            birthOptionCountry : [],
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            birthSelectedCity: ""
        }
    }

    // Select Area

    handleBirthSelectNationality = (birthSelectNationality) => {
        let selected = birthSelectNationality.value;
        if (selected == "Dalam Negeri") {
            this.setState({
                birthSelectedCountry: "444fbff9-52d6-4d61-9150-b5060055e560",
                isLocal: 1
            })
        } else {
            this.setState({
                birthSelectedCountry: "",
                isLocal: 0
            })
        }
    }

    handleBirthSelectCountry = (birthSelectedCountry) => {
        let selected = birthSelectedCountry.value;
        this.getBirthProvinceByCountry(selected);
    }

    getBirthProvinceByCountry(selected_uuid){
        this.updateBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionProvince: reformatOptions(
                                response.result, 
                                'signatories_official_position',
                                'signatories_official_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionProvince({
          //is_local: 1,
          parent_uuid : selected_uuid,
          type : 2  
        })
    }

    handleBirthSelectProvince = (birthSelectedProvince) => {
      this.setState({
        birthSelectedProvince: birthSelectedProvince.value
      });

      // get data city where province selected
      this.updateBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      
                      this.setState({
                          birthOptionCity: reformatOptionRegion(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.updateBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : birthSelectedProvince.value
      })
    }

    handleBirthSelectCity = (birthSelectedCity) => {
      this.setState({
        birthSelectedCity: birthSelectedCity.value
      });
    }

    handleSelectGender = (selectedGender) => {
        this.setState({
            selectedGender: selectedGender.value
        });
    }

    // End Select Area

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response);
                        this.setState({
                            dataForm: {
                              uuid: response.assignment_history_uuid,
                              employee_uuid: response.assignment_history_employee_uuid,
                              assignment_history_type: response.assignment_history_type,
                              assignment_history_type_national: response.assignment_history_type_national,
                              assignment_history_start_date: response.assignment_history_start_date,
                              assignment_history_end_date : response.assignment_history_end_date,
                              assignment_history_number : response.assignment_history_number,
                              assignment_history_date : response.assignment_history_date,
                              assignment_history_cost_reference : response.assignment_history_cost_reference,
                              assignment_history_desc : response.assignment_history_desc,
                              assignment_history_activity_type : response.assignment_history_activity_type,
                              assignment_history_place : response.assignment_history_place,
                              assignment_history_long_time : response.assignment_history_long_time,
                              assignment_history_approved_uuid : response.assignment_history_approved_uuid
                            },
                            birthSelectedCountry : response.assignment_history_approved_uuid,
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })

         // get data birth country
         this.updateBloc.regionCountryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionCountry: reformatOptions(
                                response.result, 
                                'signatories_official_position',
                                'signatories_official_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionCountry({
          type : 1  
        })

        // get data birth province
        this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

        // get data province
          this.updateBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionProvince: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionProvince({
          is_local: 1,
          type : 2  
        })

        // get data city where province selected
        this.updateBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionCity: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionCity({
          is_local: 1,
          type : 3,
          parent_uuid : this.state.birthSelectedProvince
        })
      
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayatpenugasan"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Edit Data Riwayat Penugasan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                      {/* Masih HardCode */}
                                      <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="assignment_history_uuid"
                                            value={this.state.dataForm.uuid}
                                      />
                                      <AvField
                                            name="employee_uuid"
                                            type="hidden"
                                            id="employee_uuid"
                                            value={this.state.dataForm.employee_uuid}
                                      />
                                      {/* Sampai Sini */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Penugasan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="assignment_history_type"
                                                    errorMessage="Pilih Jenis Penugasan"
                                                    options={this.state.optionGender} 
                                                    placeholder="Pilih Jenis Penugasan"
                                                    defaultValue={this.state.dataForm.assignment_history_type}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Tugas <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="assignment_history_type_national"
                                                    errorMessage="Pilih Jenis Tugas"
                                                    options={this.state.optionNational} 
                                                    placeholder="Pilih Jenis Tugas"
                                                    defaultValue={this.state.dataForm.assignment_history_type_national}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Mulai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_start_date"
                                                    placeholder="Tanggal Mulai..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_start_date"
                                                    value={this.state.dataForm.assignment_history_start_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Selesai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_end_date"
                                                    placeholder="Tanggal Selesai..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_end_date"
                                                    value={this.state.dataForm.assignment_history_end_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Penugasan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_number"
                                                    placeholder="Nomor Penugasan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Penugasan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_number"
                                                    value={this.state.dataForm.assignment_history_number}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Penugasan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_date"
                                                    placeholder="Tanggal Penugasan..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Penugasan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_date"
                                                    value={this.state.dataForm.assignment_history_date}
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_approved_uuid"
                                                    placeholder="Pejabat Penetap..."
                                                    type="text"
                                                    errorMessage="Masukkan Pejabat Penetap"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_approved_uuid"
                                                    value={this.state.dataForm.signatories_official_position}
                                                />
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="tempat_lahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            {/* <Col md="5">
                                                <CustomSelect 
                                                    name="assignment_history_approved_uuid"
                                                    errorMessage="Pilih Pejabat Penetap"
                                                    onChange={this.handleBirthSelectCountry}
                                                    options={this.state.birthOptionCountry} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pejabat Penetap"
                                                    defaultValue={this.state.birthSelectedCountry}
                                                />
                                            </Col> */}
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_approved_uuid"
                                                    placeholder="Pejabat penetap..."
                                                    type="text"
                                                    errorMessage="Masukkan Pejabat penetap"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_approved_uuid"
                                                    value={this.state.dataForm.assignment_history_approved_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Sumber Pembiayaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_cost_reference"
                                                    placeholder="Sumber Pembiayaan..."
                                                    type="text"
                                                    errorMessage="Masukkan Sumber Pembiayaan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_cost_reference"
                                                    value={this.state.dataForm.assignment_history_cost_reference}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_desc"
                                                    placeholder="Keterangan..."
                                                    type="text"
                                                    errorMessage="Masukkan Keterangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_desc"
                                                    value={this.state.dataForm.assignment_history_desc}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kegiatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_activity_type"
                                                    placeholder="Jenis Kegiatan..."
                                                    type="text"
                                                    errorMessage="Masukkan Jenis Kegiatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_activity_type"
                                                    value={this.state.dataForm.assignment_history_activity_type}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tempat Organisasi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_place"
                                                    placeholder="Tempat Organisasi..."
                                                    type="text"
                                                    errorMessage="Masukkan Tempat Organisasi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_place"
                                                    value={this.state.dataForm.assignment_history_place}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Lama (hari) <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="assignment_history_long_time"
                                                    placeholder="Lama (hari)..."
                                                    type="text"
                                                    errorMessage="Masukkan Lama (hari)"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assignment_history_long_time"
                                                    value={this.state.dataForm.assignment_history_long_time}
                                                />
                                            </Col>
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayatpenugasan">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayatpenugasan'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);